import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `الصفحة الرئيسية لـ ${ctx.brand}`,
    languageButtonLabel: `اللغة`,
    languageModalTitle: `اختر لغة`,
    languageModalCloseLabel: `إغلاق قائمة اللغات`,
  },
  languageOptions: {
    'en-US': {
      label: `الإنجليزية`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `الإنجليزية (كينيا)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `الإنجليزية (نيجيريا)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `الإنجليزية (سنغافورة)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `البرتغالية`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `الألمانية`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `الإسبانية`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `الفرنسية`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `الإيطالية`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `الهولندية`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `الإسكندنافية والبلطيقية`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `اليابانية`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `الكورية`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `الصينية (الصين)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `الصينية (هونغ كونغ الصينية (منطقة إدارية خاصة))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `التايلاندية`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `الهندية`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `الفارسية`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `الروسية`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `العربية`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `اختر لغة`,
    closeLabel: `إغلاق قائمة اللغات`,
  },
  languageHint: (ctx) => `تنقّل بين أكثر من ${ctx.localesCount}+ لغة.`,
  readPagePrompt: ({languageLabel}) => `اقرأ هذه الصفحة بـ${languageLabel}.`,
};
